// extracted by mini-css-extract-plugin
module.exports = {"bar-mobile":"styles_bar-mobile__1jMB8","back":"styles_back__1qmC4"};